module.exports = __webpack_public_path__ + "static/img/namoda.af3a6e96.svg";